import styled, { css } from 'styled-components/macro'

import { Href } from 'components/ui'

export const Wrap = styled.div`
  position: static;
  padding: 2rem 0;
  display: flex;
  flex-direction: column;
  ${(props) => props.theme.breakpoints.greaterThan('sm')`
    padding: 2rem 0 0;
  `};
`

export const StyledLink = styled(Href)`
  padding: 0.2rem 0.4rem;
  width: 100%;
  display: inline-flex;
  align-items: center;
  gap: 0.6rem;
  text-align: center;
  color: ${(props) => props.theme.color.text};
  border-radius: 0.8rem;
  &:hover {
    color: ${(props) => props.theme.color.textHint};
  }
  ${(props) => props.theme.breakpoints.greaterThan('sm')`
    justify-content: center;
    &:hover {
      color: ${props.theme.color.text};
      background-color: ${props.theme.color.buttonBgThird};
    }
  `};
`

export const Row = styled.div<{ type?: string }>`
  padding: 0.5rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 2rem;
  font-size: 1.4rem;
  text-transform: capitalize;
  ${(props) =>
    props.type === 'header' &&
    css`
      margin: 0 0 1rem;
      border-bottom: 0.1rem solid ${(props) => props.theme.color.elementBorder};
    `}
  ${(props) =>
    props.type === 'transaction' &&
    css`
      width: 14rem;
    `}
`

export const Column = styled.span<{ type?: string }>`
  width: 16rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  ${(props) =>
    props.type === 'typeValue' &&
    css`
      display: none;
      font-size: 1.2rem;
      line-height: 2;
      ${(props) => props.theme.breakpoints.greaterThan('sm')`
        display: flex;
        width: 14rem;
      `};
    `}
  ${(props) =>
    props.type === 'status' &&
    css`
      text-align: right;
    `}
`

export const Pagination = styled.div`
  margin: 0.5rem 0 0;
  padding: 1.2rem 0 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 1.6rem;
  border-top: 0.1rem solid ${(props) => props.theme.color.elementBorder};
  ${(props) => props.theme.breakpoints.greaterThan('sm')`
    flex-direction: row;
  `};
`

export const PaginationText = styled.span`
  width: 100%;
  font-size: 1.4rem;
`

export const PaginationButtons = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  justify-content: space-between;
  align-items: center;
  gap: 0.4rem;
`

export const MobileHash = styled.span`
  width: auto;
  ${(props) => props.theme.breakpoints.greaterThan('sm')`
    display: none;
  `};
`

export const DesktopHash = styled.span`
  display: none;
  ${(props) => props.theme.breakpoints.greaterThan('sm')`
    display: flex;
  `};
`

export const NoContent = styled.div`
  display: flex;
  flex-direction: column;
`

export const IconWrap = styled.span`
  margin: 0 auto 3rem;
  width: 8rem;
`

export const Title = styled.p`
  margin: 0;
  font-weight: ${(props) => props.theme.font.weight.regular};
  font-size: 1.6rem;
  line-height: 1.12;
  text-align: center;
  color: ${(props) => props.theme.color.text};
`
